import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success('¡Bienvenido a LivCom!');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Left side - Form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="mb-8 text-center">
            <div className="flex items-center justify-center gap-3 mb-6">
               <img 
                src="https://customer-assets.emergentagent.com/job_admin-central-39/artifacts/g46w9dxw_Favicon.png" 
                alt="LivCom" 
                className="h-10 w-10"
              />
               <span className="text-3xl font-heading font-bold text-primary">LivCom</span>
            </div>
            <h1 className="text-2xl font-heading font-semibold text-slate-900 mb-2">
              Bienvenido de nuevo
            </h1>
            <p className="text-slate-500">
              Ingresa a tu panel de control operativo
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="admin@ejemplo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="email-input"
                className="mt-1"
              />
            </div>

            <div>
              <div className="flex items-center justify-between">
                <Label htmlFor="password">Contraseña</Label>
                <Link
                  to="/forgot-password"
                  className="text-sm text-accent hover:underline"
                  data-testid="forgot-password-link"
                >
                  ¿Olvidaste tu contraseña?
                </Link>
              </div>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="password-input"
                className="mt-1"
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-accent hover:bg-accent/90 text-white rounded-full py-6 font-semibold"
              disabled={loading}
              data-testid="login-submit-button"
            >
              {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
            </Button>
          </form>

          <p className="text-center text-text-secondary mt-6 text-sm">
            El acceso es por invitacion.{' '}
            <Link to="/forgot-password" className="text-accent font-medium hover:underline" data-testid="register-link">
              ¿Olvidaste tu contraseña?
            </Link>
          </p>

          <Link to="/" className="block text-center text-text-secondary mt-4 hover:text-primary" data-testid="back-home-link">
            ← Volver al inicio
          </Link>
        </div>
      </div>

      {/* Right side - Image */}
      <div className="hidden lg:block flex-1 bg-gradient-to-br from-primary to-primary/90 relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center p-12">
          <div className="text-white text-center">
            <h2 className="text-4xl font-heading font-bold mb-4">
              Tu operacion, bajo control.
            </h2>
            <p className="text-xl text-white/80">
              Gestion multi-conjunto con IA diseñada para LATAM.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;